import { useTskContext } from '@Hooks/useTskContext';
import { Cell, Row, SkeletonAvatar, SkeletonCheckbox, SkeletonText } from '@tlx/atlas';

export function TableLoading() {
    const { hasDivision, showDepartmentIsWageAdmin } = useTskContext();

    const amountOfColumns = 5 + (showDepartmentIsWageAdmin ? 1 : 0) + (hasDivision ? 1 : 0);
    return (
        <>
            {Array.from({ length: 15 }).map((_, index) => (
                <Row key={index} className="">
                    <Cell className="">
                        <SkeletonCheckbox />
                    </Cell>
                    <Cell className={'atl-flex atl-gap-8'}>
                        <SkeletonAvatar />
                        <SkeletonText className="atl-w-full" />
                    </Cell>
                    {/* this should be based on the amount of columns, taken in as props?*/}
                    {Array.from({ length: amountOfColumns - 1 }).map((_, index) => (
                        <Cell key={index}>
                            <SkeletonText className="atl-w-full" />
                        </Cell>
                    ))}
                </Row>
            ))}
        </>
    );
}
